import moment from 'moment';
import React from 'react';
import 'moment-timezone';
import { getPrimaryAccount, getAccountData, isGeminiUser } from './sessionUtil';
import formatter from './formatter';
import { getFreezeFeaturesList } from './freezeUtil';
import LinkTooltipContainer from '../CommonComponents/LinkTooltipContainer';
import { logUiError,findAdditionalAccountDetails } from '../services/apiServices';


export const checkForFreezeFunctionality = () => {
  const userData = getAccountData();
  const primaryAccount = getPrimaryAccount();
  const { partyFreezes } = userData;
  const { freezes } = primaryAccount;
  return getFreezeFeaturesList(partyFreezes, freezes);
}


export const handleDisabled = ({advisorType,userType,addSecondaryAdv,isNewSecondaryAdvisor})=>{

  return !( (advisorType === "Primary" && userType === "primary" && !addSecondaryAdv) ||
  (advisorType === "Secondary" && userType === "secondary") ||
  (advisorType === "Secondary" && isNewSecondaryAdvisor === true))

}

export const getBaseUrl = () => {
  if(isGeminiUser()) {    
    return process.env.REACT_APP_CSR_API_BASE_URL;
  } else {
    return process.env.REACT_APP_API_BASE_URL;
  }
};

export const getBhoomiCreds = ()=>{return {
  uname:process.env.REACT_APP_BHOOMI_USERNAME,
  password:process.env.REACT_APP_BHOOMI_PASSWORD
}}

export const getBhoomiURL = ()=>{let url =  process.env.REACT_APP_BHOOMI_URL;return url};

export const getpwUrl = () => {
  return process.env.REACT_APP_DRUPAL_BASE_URL;
};

export const startDate = o => {
  var d = moment()
    .subtract(o, 'days')
    .format('L');
  return d;
};

export const isFutureDate = d => moment(d).isAfter(moment());

export const todayDate = () => {
  var todayDate = moment.tz(new Date(), 'America/New_York');
  var today = todayDate.format('L');
  return today ;
};

export const oneYearBackDate =()=> {
  const today = moment();
  const prevYear =moment().subtract(1, 'years');
  return prevYear.format('MM/DD/YYYY')
}

export const session = () => {
  let userData = JSON.parse(sessionStorage.getItem('userData'));
  return userData;
};

export const milliToDate = date => {
  return moment.tz(date, 'America/New_York').format('L');
};

export const dateFormatter = date => {
  return moment(date).format('MM/DD/YYYY')
};

export const milliToDateTime = date => {
  return moment(moment.tz(date, 'America/New_York')).format(
    'DD MMM YYYY hh:mm a'
  );
};

//returns time in HH:MM AM format
export const milliToTime = date => {
  return moment(moment.tz(date, 'America/New_York')).format('LT');
};

export const adminUsage = {
  isAdminPage:
    sessionStorage.getItem('isAdminPage') != null ||
      sessionStorage.getItem('isAdminPage') != undefined
      ? JSON.parse(sessionStorage.getItem('isAdminPage'))
      : sessionStorage.getItem('userData')
        ? JSON.parse(sessionStorage.getItem('userData')).csrUser
        : null
};

export const financialAdvisorUsage = props => {
  if (props.location.pathname.toLowerCase() === '/financialadvisor') {
    return true;
  }
};

const dataLayerObject = {
  tabClick: {
    event: 'Analytics Tabs',
    eventcategory: '',
    eventaction: '', //<heading>- ex- "Account Overview" or "Investment Overview"
    eventlabel: '' //<text> -"Text Value of Clicked Tabs"  ex-"Grant,contribution,exchange or other transactions" in https://uat2.vcapps.org/build/
  },
  botEvents: {
    event: 'Analytics RangeSelection',
    eventcategory: '',
    eventaction: '',
    eventlabel: '' //<text> - "1M","3M".
  },
  showMore: {
    event: 'Analytics ShowMore',
    eventcategory: 'Tab section', //"Tab section" - "My Investments" or "Portfolio or IOD
    eventaction: '', // Tab
    eventlabel: '' //<text heading> Example : Show more - Growth
  },
  learnMore: {
    event: 'Analytics LearnMore',
    eventcategory: '', //Investment Overview
    eventaction: '', //"Money Market","Total Bond","Wellington","Lorem ipsum" .etc.
    eventlabel: '' //<learn more>
  },
  investmentPerformance: {
    event: 'Analytics VIPerformance',
    eventcategory: '', //Investment Overview
    eventaction: '',
    eventlabel: '' //"View Investment Performance"
  },
  edit: {
    event: 'Analytics Edit',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  exit: {
    event: 'Analytics Exit',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  update: {
    event: 'Analytics Update',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  update2: {
    event: 'Analytics Update2',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  remove: {
    event: 'Analytics Remove',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  select: {
    event: 'Analytics Select',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  export: {
    event: 'Analytics Export',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  print: {
    event: 'Analytics Print',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  cancel: {
    event: 'Analytics Cancel',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  cancel2: {
    event: 'Analytics Cancel2',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  viewEdit: {
    event: 'Analytics ViewEdit',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  reverse: {
    event: 'Analytics Reverse',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  cancelTable: {
    event: 'Analytics CancelTable',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  download: {
    event: 'Analytics Download',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  interestedParty: {
    event: 'Analytics InterestedParties',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  submit: {
    event: 'Analytics Submit',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  taxReceipts: {
    event: 'Analytics TaxReceipts',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  needAssistance: {
    event: 'Analytics NeedAssistance',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  grantOverviewTopLink: {
    event: 'Analytics GrantOverviewTopLink',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  back: {
    event: 'Analytics Back',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  back2: {
    event: 'Analytics Back2',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  button: {
    event: 'Analytics Button',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  addPayment: {
    event: 'Analytics AddPayment',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  addExchange: {
    event: 'Analytics ExchangeButton',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  buttonStep: {
    event: 'Analytics ButtonStep',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  addGrant: {
    event: 'Analytics AddGrant',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  addGrant2: {
    event: 'Analytics AddGrant2',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  clear: {
    event: 'Analytics Clear',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  next: {
    event: 'Analytics Next',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  navigationDP: {
    event: 'Analytics TopHeaderNavigationDP',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  openNewAccount: {
    event: 'Analytics Button',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  grantPaymentLetter: {
    event: 'Analytics GrantPaymentLetter',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  grantPaymentLetter2: {
    event: 'Analytics GrantPaymentLetter2',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  addSecondaryAdvisor: {
    event: 'Analytics AddSecondaryAdvisor',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  suggestCharity: {
    event: 'Analytics Suggest',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  save: {
    event: 'Analytics Save',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  globalNavigationDP: {
    event: 'Analytics GlobalHeaderNavigationDP',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  breadCrumb: {
    event: 'Analytics BreadcrumbDP',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  globalFooterDP: {
    event: 'Analytics GlobalFooterDP',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  viewFullDetails: {
    event: 'Analytics ViewFullDetails',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  chooseCharity: {
    event: 'Analytics ChooseCharity',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  email: {
    event: 'Analytics MailTo',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },  
  outBoundClick: {
    event: 'Analytics Outbound',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  headerLogo: {
    event: 'Analytics HeaderLogo',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  tabsStep: {
    event: 'Analytics TabsStep',
    eventcategory: '',
    eventaction: '',
    eventlabel: ''
  },
  eCommerce: {
    event: 'transaction',
    ecommerce: {}
  }
};

export const formatAmount = value => {
  return value ? formatter({ value, fieldSuffix: 'Dollars' }) : '$0.00';
};

export const formatShares = (value, fieldSuffix) => {
  return value ? formatter({ value, fieldSuffix: 'Units' }) : '0.0000';
}

export const formatSharesWithSixDecimal = (value) => {
  return value ? formatter({ value, fieldSuffix: 'SixDecimalUnits' }) : '-';
}

export function nameFormatter(firstName, middleName, lastName, suffix, prefix) {
  return `${prefix ? prefix : ''}${firstName ? ' ' + firstName : ''}${
    middleName ? ' ' + middleName : ''
  }${lastName ? ' ' + lastName : ''}${suffix ? ', ' + suffix : ''}`;
}

export const initiateTracking = function (type, ...params) {
  var theDataLayer = dataLayerObject;
  var tempObj = theDataLayer[type];
  let { event } = tempObj;
  var allOptions = [event, ...params];
  let count = 0;
  for (var key in tempObj) {
    if (tempObj.hasOwnProperty(key)) {
      tempObj[key] = allOptions[count];
      ++count;
    }
  }

  

  //Check for clicks are not repetetive on the same element
  var lastEntity = window && window.dataLayer? window.dataLayer[window.dataLayer.length - 1]:{};
  var differentLastEntries = false;
  for (var key in lastEntity) {
    if (lastEntity.hasOwnProperty(key)) {
      if (lastEntity[key] !== tempObj[key]) {
        differentLastEntries = true;
        break;
      }
    }
  }
  //Push to data layer only if clicks are not repetetive on the same element
  if (differentLastEntries) {
    window.dataLayer.push(tempObj);
  }
};


export const isWalkthroughVisited = screenName => {
  let sessionData = session();
  if (sessionData) {
    if (sessionData.coachMarks && sessionData.coachMarks.length === 0) {
      return true;
    } else if (!sessionData.coachMarks) {
      //Added to hide walkthrough slides if value is null and not array.
      return false;
    } else {
      if (sessionData.coachMarks) {
        let arrData = sessionData.coachMarks.filter((data, i) => {
          if (data.visistedScreen === screenName) {
            return true;
          }
          return false;
        });
        if (arrData.length > 0) {
          return false;
        }
      }
    }
  }
  return true;
};

export const createPoolArr = (pools, categoryName) => {
  const poolsMapping = {
    portfolioSolutions: 'PORTFOLIO SOLUTIONS',
    portfolioBuilders: 'PORTFOLIO BUILDERS',
    valueDriven: 'VALUES DRIVEN INVESTMENTS'
  };
  var arr = [];
  pools[categoryName].forEach(data => {
    var newObj = {
      fullPoolName: data.investmentOption,
      isRise: data.rise,
      pricePerUnit: data.currentNav,
      poolCategoryDesc: poolsMapping[categoryName],
      poolClass: data.poolClass,
      id: Number(data.poolId),
      asOfDate: data.asOfDate
    };
    arr.push(newObj);
  });
  return arr;
};

export const flattenArr = pools => {
  let flattenPoolArr = [];
  var categoryArr = ['portfolioSolutions', 'portfolioBuilders', 'valueDriven'];
  let filterPool = pools.filter((pool, i) => {
    if (pool.accountType === getPrimaryAccount().accountType) {
      return true;
    }
    return false;
  });
  categoryArr.forEach(obj => {
    flattenPoolArr.push(...createPoolArr(...filterPool, obj));
  });
  return flattenPoolArr;
};

export const mergeArray = (investPoolData, allPoolData) => {
  let secondNewArr = [];
  allPoolData &&
    allPoolData.map(each => {
      let checkVar = check(investPoolData, each.id);
      if (
        checkVar === 0 &&
        getPrimaryAccount()?.accountType?.toUpperCase() ===
        each.poolClass.description.toUpperCase()
      ) {
        let obj = {
          availableBalance: 0,
          availableUnits: 0,
          currentBalance: 0,
          currentNAV: 0,
          dateChanged: 0,
          isRise: each.isRise,
          marketValue: 0,
          percentShare: 0,
          poolCategory: each.poolCategoryDesc,
          poolId: each.id,
          poolName: each.fullPoolName,
          pricePerUnit: each.pricePerUnit,
          roi: 0,
          startDate: 0,
          type: each.poolClass.description.toUpperCase(),
          unitsHeld: 0,
          asOfDate: each.asOfDate
        };
        secondNewArr.push(obj);
      }
    });
  let mergedArr = investPoolData.concat(secondNewArr);
  mergedArr.map(each => {
    if (
      each.poolCategory !== 'PORTFOLIO SOLUTIONS' &&
      each.poolCategory !== 'VALUES DRIVEN INVESTMENTS'
    ) {
      each.poolCategory = 'PORTFOLIO BUILDERS';
    }
  });
  return mergedArr;
};

export function check(newArray, checkPoolId) {
  let flag = 0;
  newArray &&
    newArray.map(each => {
      if (each.poolId === checkPoolId) {
        flag = 1;
      }
    });
  return flag;
}

export const roundWith = number => {
  let num = number;
  if (!isNaN(number)) {
    num = Math.round(number * 100) / 100;
  }
  return num;
};

export const getColumnLength = (length) => {
  if(length){
    return 85/length;
  }
}

export const docNameFormatter = (name) => {
  if (typeof (name) === 'string') {
    let newName = '';
    if (name.indexOf(' - ') === -1) {
      newName = name;
    } else {
      newName = name.substr(name.indexOf(' - ') + 3) + ' - ' + name.substr(0, name.indexOf(' - '));
    }
    return newName;
  } else {
    return name;
  }
}
export function removeDuplicates(array, key) {
  return array.filter((obj, index, self) =>
    index === self.findIndex((el) => (
      el[key] === obj[key]
    ))
  )
}

/**
 * scrollTo position
 * @param  value
 */
export const moveIntoErrorPosition = (errorClass, index) => {
  let element = document.querySelector(`${errorClass}`);
  if(index) {
    element = document.querySelectorAll(`${errorClass}`)[index];
  }
  /** Calculating top Position from the element to the window */
  if(element) {
    /** Check for element existence */
    let topPos = element.getBoundingClientRect().top + window.pageYOffset; 
    /** Need to subtract to 250px from the top as the element is hidden under header */
    topPos -= 246;
    /** Returns true if it is Internet Explorer */
    if(!!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)){
      window.scrollTo(0,topPos);
    }else{
      window.scrollTo({
        top: topPos,
        behavior: 'smooth',
      });
    }

  }
}



export const replaceAnchorWithLink = (text = "", type = 'anchor',tooltipData="", highlightMenu = false, htmlLink= false) => {
  /**
   * type : link/anchor/tooltip
   */
	let anchorLinks = [];
	/** Example 1: Extracting the Href values using RegEx */
	var res = text.match(/<a href="(.*?)"/g);
	res && res.length &&
		res.map(data => {
			let link = data.match(/"(.*?)"/g)[0];
			link = link.replace('"', '').slice(0, -1);
			anchorLinks.push(link);
		});
	/** [Back-up Solution] Example 2: Storing the text in a HTML element to extract all the anchor tags [Comment Example 1 - If it is creating issues] */
	//   let container = document.createElement('div');
	//   container.innerHTML = text;
	//   let anchorLinks = [];
	//   let allAnchorTags = container.getElementsByTagName('a');
	//   /** Fetching all href links and storing in a different Array */
	//   for (tag of allAnchorTags) {
	//       anchorLinks.push(tag.getAttribute('href'));
	//       console.log(tag.href);
	//   }

	let finalString = [];
	/** Replacing the original text anchor links with ~ */
	let contentSansAnchors = text.replace(/<\/?a[^>]*>/g, '~');
	/** Splitting the text into array with ~ */
	let contentArray = contentSansAnchors.split('~');
	let count = 0;
	/** Adding Links / Tooltip / Etc */
	contentArray.length &&
		contentArray.forEach((data, i) => {
			if (i % 2 !== 0) {
        if(type === 'link'){
          data = (<LinkTooltipContainer to={anchorLinks[count]} link={true} data = {htmlLink ? <span dangerouslySetInnerHTML={{ __html: data }}></span> : data} headerChange={highlightMenu} />)
        }
				if (type === 'tooltipAnchor') {
					data = (<LinkTooltipContainer title={tooltipData} href={anchorLinks[count]} data={data} />)
				}
				count++;
			}
			finalString.push(data);
    });
	return finalString;
};


/* eligibilityChecker function checks the eligibility of each charity and 
   returns an Object which includes mandatory check and partial eligibility check */ 

export const charityEligibilityChecker = ({ pub78, bmfStatus, subSection, foundationCode }) => {
  const eligibleSubSection = "501(c)(3) Public Charity";
  const formattedSubSectionCheck =
    subSection.toLocaleLowerCase().split(" ").join("") ===
    eligibleSubSection.toLocaleLowerCase().split(" ").join("");
  const foundationCheck = [
    "2",
    "3",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "21",
    "22",
    "23",
  ].includes(foundationCode);
  const mandateCheck =
    pub78 === true &&
    bmfStatus === true &&
    formattedSubSectionCheck &&
    foundationCheck;
  if (mandateCheck) {
    if (foundationCode === "17") {
      return {
        mandatory: true,
        partial: false,
      };
    } else {
      return {
        mandatory: true,
        partial: true,
      };
    }
  } else {
    return {
      mandatory: false,
      partial: false,
    };
  }
};

export const getZipCodeDetails = (zipcode = '') => {
  return new Promise((resolve, reject) => {
    if(zipcode) {
      if(window.google) {
        const geocoder = new window.google.maps.Geocoder();      
        geocoder.geocode({
          componentRestrictions: {
            country: 'US',
            postalCode: zipcode
          }
        }, (response) => {        
          resolve(response);
        })
      } else {
        reject("Something went wrong");
      }
    } else {
      reject('Please provide a zipcode');
    }
  })
}

export const checkIEBrowser = () => {
  return (window.navigator.userAgent.indexOf('Trident/') > 0 || window.navigator.userAgent.indexOf('Edge/') > 0);
}

export const recordError = (error, errorInfo="",isAuth=true) => {
  if(isAuth){ 
  const userData = getAccountData();  
  if(!userData) {
    return;
  }
  
  let param = {
    errorDetails:  errorInfo ? error.toString() + " at " + error.stack.toString().split(' at ')[1] + errorInfo.componentStack.toString().split('\n')[1]: error.toString() + " at " + error.stack.toString().split(' at ')[1],
    accountId: userData.PrimaryAccountForParty,
    applicationName: "donorPortalUI",
    logType: "UIErrorLog",
    time: moment.tz(new Date(), 'America/New_York').format("MM/DD/YYYY HH:mm:ss")
  }
  return logUiError('/writeLog', param,isAuth);
  }else {
  let param = {
    errorDetails:  errorInfo ? error.toString() + " at " + error.stack.toString().split(' at ')[1] + errorInfo.componentStack.toString().split('\n')[1]: error.toString() + " at " + error.stack.toString().split(' at ')[1],
    applicationName: "donorPortalUI",
    logType: "UIErrorLog",
    time: moment.tz(new Date(), 'America/New_York').format("MM/DD/YYYY HH:mm:ss")
  }
  return logUiError('/authuser/writeLog', param,isAuth);
  }
}


/**
 * How to use: actionNameGenerator
 * 
 *  example:
 *    const domainActionNameGenerator = actionNameGenerator('domainPrefix');
 *    const fetchRecentGrantType = domainActionNameGenerator(“fetchRecentGrant“);
 */

export const actionNameGenerator = (domainPrefix) => {
  return (actionType) => `${domainPrefix}/${actionType}`;
}
export const formatDate = (data) => {
  if (data) {
    let date = moment(data, "DD-mm-YYYY");
    let result = date.format("mm/DD/YYYY");
    return result;
  }
  return;
}

export const dateDiff = (d1, d2, type = 'days') => {
  /* Date formate should be in 'DD/MM/YYYY' format */
  if (d1 && d2) {
    const firstDate = moment(d1, 'DD/MM/YYYY');
    const secDate = moment(d2, 'DD/MM/YYYY');
    return secDate.diff(firstDate, type);
  } else {
    return;
  }
}

export const isAllShareAllPool = () => {
  const userData = getAccountData();
  if(userData !=null && userData.allShareAllPoolGrantExist) {
      return userData.allShareAllPoolGrantExist;
  }else{
      return false;
  }
};

export const changeAllShareAllPoolStatus = () => {
  findAdditionalAccountDetails()
    .then(res => res.json())
    .then(
      (result) => {
      const userData = getAccountData();
      if(result !=null && result.allShareAllPoolGrantExist) {
        let allShareAllPoolGrantExist = { ...userData, ...{"allShareAllPoolGrantExist" : true }};
        sessionStorage.setItem("userData", JSON.stringify(allShareAllPoolGrantExist));
      }else if(result !=null && !result.allShareAllPoolGrantExist) {
        let allShareAllPoolGrantExist = { ...userData, ...{"allShareAllPoolGrantExist" : false }};
        sessionStorage.setItem("userData", JSON.stringify(allShareAllPoolGrantExist));
      }
      }
    ) 
};